import React from 'react';
import {Tabs} from 'antd';
import DcpOrderExportedList from './DcpOrderExportedList.js';
import DcpOrderExportedDetail from './DcpOrderExportedDetail.js'
const { TabPane } = Tabs;
class DcpOrderExported extends React.Component{
  
    constructor(props) {
      super(props);  
      this.state={
        activeKey:"1"
      }
    }
      callback(activeKey,type,params){
          if(type == "details"){
            this.state.params = params
          }
          if(type == "add"){
            this.state.params = null
          }
        this.setState({activeKey:activeKey})
      }
    render(){
      const {isfalse}=this.state
        return(
          <div>
            <Tabs type="card" activeKey={this.state.activeKey} onChange= {this.callback.bind(this)}>
            <TabPane tab="待处理DCP列表" key="1">
              <DcpOrderExportedList  buttonList={this.props.buttonList} callback = {this.callback.bind(this)}/>
            </TabPane>
            <TabPane tab="待处理DCP详情" key="2">
            <DcpOrderExportedDetail buttonList={this.props.buttonList} params = {this.state.params} callback = {this.callback.bind(this)}/>
            </TabPane>
          </Tabs>
          </div>
        )
    }
}
export default DcpOrderExported;